<template>
    <div class="page-content page-content-full">
        <h1>Maintenance</h1>
        <p v-if="configuration">{{ configuration.maintenanceMessage }}</p>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'MaintenanceView',
        computed: {
            ...mapGetters(['configuration'])
        },
        created() {
            if (!this.configuration.maintenanceMode) {
                this.$router.push('/performance')
            }
        }
    }
</script>
